module.exports = __webpack_public_path__ + "static/media/hpm-image-1.83bcfd70.jpeg";